import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import { fetchUserQuery } from '@/store/graphql/queries/user';
import { SSOChangePassword, SSOUpdateProfile } from '@/store/graphql/mutations/user';

const user = {
  namespaced: true,
  state: {
    users: [],
    user: null,
  },
  actions: {
    async get({ commit }, userId) {
      try {
        const userQuery = {
          query: fetchUserQuery,
          variables: {
            userId,
          },
        };
        const result = await apolloClient.query(userQuery);
        if (result && result.data) {
          commit('SET_CURRENT_USER_VIEW', result.data.user_by_pk);
        } else {
          commit('SET_CURRENT_USER_VIEW', null);
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async changePassword(store, data) {
      try {
        const userUpdateQuery = {
          mutation: SSOChangePassword,
          variables: {
            password: {
              currentPassword: data.currentPassword,
              password: data.password,
              confirmPassword: data.confirmPassword,
            },
          },
        };
        const result = await apolloClient.mutate(userUpdateQuery);
        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async updateProfile(store, data) {
      try {
        const userUpdateQuery = {
          mutation: SSOUpdateProfile,
          variables: {
            account: {
              userName: data.name,
              email: data.email,
            },
          },
        };

        const result = await apolloClient.mutate(userUpdateQuery);
        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  mutations: {
    SET_CURRENT_USER_VIEW(state, userData) {
      Vue.set(state, 'user', userData);
    },
  },
  getters: {
    userInfo: state => state.user,
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/core/user.js